/* tslint:disable:max-line-length */
import { Directive, TemplateRef } from '@angular/core';
/**
 * Used for rendering content when there is no data present.
 *
 * To define the no-data template, nest a `<ng-template>` tag with the `kendo<ComponentName>NoDataTemplate` directive inside the component tag.
 *
 * Use:
 * - The `kendoAutoCompleteNoDataTemplate` directive for the AutoComplete.
 * - The `kendoComboBoxNoDataTemplate` directive for the ComboBox.
 * - The `kendoDropDownListNoDataTemplate` directive for the DropDownList.
 * - The `kendoMultiSelectNoDataTemplate` directive for the MultiSelect.
 *
 *
 * @example
 * ```ts
 * @@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxNoDataTemplate>
 *      <h4>No data!</h4>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = [];
 * }
 * ```
 *
 * For more examples, refer to the article on [templates]({% slug overview_ddl_kendouiforangular %}#toc-templates).
 */
var NoDataTemplateDirective = (function () {
    function NoDataTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    return NoDataTemplateDirective;
}());
export { NoDataTemplateDirective };
NoDataTemplateDirective.decorators = [
    { type: Directive, args: [{
                selector: '[kendoDropDownListNoDataTemplate],[kendoComboBoxNoDataTemplate],[kendoAutoCompleteNoDataTemplate],[kendoMultiSelectNoDataTemplate]'
            },] },
];
/** @nocollapse */
NoDataTemplateDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dropdowns/dist/es/templates/no-data-template.directive.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/templates/no-data-template.directive.js
// module chunks = 3